import { BlockType, AllScience35Blocks } from "shared/types/science35Types"

export function toProductString(block: BlockType): string {
    if (AllScience35Blocks.includes(block)) {
        return "science35"
    }
    if (block === "Science 68") {
        return "science68"
    }
    if (block === "Science ESS") {
        return "scienceESS"
    }
    if (block === "Science Bio") {
        return "scienceBio"
    }
    return ""
}

export function toBlockType(blockString: string): BlockType {
    const sci35 = blockString === "science35"
    const sci68 = blockString === "science68" 
    const sciESS = blockString === "scienceESS"
    const sciBio = blockString === "scienceBio"
    return sci35 ? "Science 35" : sci68 ? "Science 68" : sciBio ? "Science Bio" : sciESS ? "Science ESS" : null
}
